<template>
  <div class="dropdown">
    <button v-if="color==='teal'" class="btn-regular" :class="{teal : isSet || isCustomSet, secondary : !isSet}" @click.stop="toggledDropdown">{{labelDropdown}}</button>
    <button v-else class="btn-regular" :class="{pink : isSet, secondary : !isSet}" @click.stop="toggledDropdown">{{labelDropdown}}</button>
    <media :query="{minWidth: 769}">
      <div v-if="isShown" class="dropdown__menu" @click.stop="isShown = true">
        <div class="dropdown__menu__wrapper__loading" v-if="loading">
          <adx-loading/>
        </div>
        <div class="dropdown__menu__wrapper" v-else>
          <ul class="dropdown__menu__wrapper__sub">
            <li v-for="item in list" :key="item.id" @click.stop="select(item)"
              class="dropdown__menu__wrapper__sub__item" :class="{selected: item.id == selected}">
              <span>{{ item.label }}</span>
            </li>
          </ul>
        </div>
      </div>
    </media>
    <media :query="{maxWidth: 769}">
      <modal v-if="isShown" :title="title" @modal-close="closeDropdown">
        <template slot="content">
          <div class="dropdown__menu" @click.stop="isShown = true">
            <div class="dropdown__menu__wrapper__loading" v-if="loading">
              <adx-loading/>
            </div>
            <div class="dropdown__menu__wrapper" v-else>
              <ul class="dropdown__menu__wrapper__sub">
                <li v-for="item in list" :key="item.id" @click.stop="select(item)"
                  class="dropdown__menu__wrapper__sub__item" :class="{selected: item.id == selected}">
                  <span>{{ item.label }}</span>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </modal>
    </media>
  </div>
</template>

<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import LoadingPrimary from '@/components/Loading/Primary'

export default {
  name: 'adx-dropdown-list',
  components: {
    'media': Media,
    'modal': Modal,
    'adx-loading': LoadingPrimary,
  },
  props: {
    loading: {
      required: false,
      default: false,
    },
    list: {
      type: Array,
      required: true,
    },
    labelButton: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    valueDisplay: {
      required: false
    },
    color: {
      required: false,
      default: 'teal'
    },
    isCustomSet: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      isShown: false,
      isSet: false,
      selected: null,
      selectedValue:null,
      labelDropdown: '',
      firstLabelDropdown: ''
    }
  },
  watch: {
    labelButton() {
      this.labelDropdown = this.labelButton
    },
    valueDisplay() {
      if (!this.valueDisplay) {
        this.labelDropdown = this.firstLabelDropdown
        this.isSet = false
        this.selected = null
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
    this.labelDropdown = this.labelButton
    this.firstLabelDropdown = this.labelButton
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeDropdown()
      }
    })
  },
  updated() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
  },
  methods: {
    toggledDropdown(sender) {
      Vue.$broker.$emit("app-click", this)
      this.isShown = !this.isShown
    },
    closeDropdown(sender) {
      if (sender === this) {
        return
      }
      this.isShown = false
    },
    select(item) {
      // this.$emit('selected', item)
      if (this.selected == item.id) {
        this.selected = null
        this.selectedValue = null
        this.labelDropdown = this.firstLabelDropdown
        this.isSet = false
      } else {
        this.labelDropdown = item.label
        this.selected = item.id
        this.selectedValue = item.value
        this.isSet = true
      }
      let label =  this.labelDropdown === this.firstLabelDropdown ? null : this.labelDropdown
      // let item_temp = {...item}
      // item_temp.label = label
      // item_temp.value = this.selectedValue

      this.$emit('selected', {id:item.id, value:this.selectedValue, label:this.firstLabelDropdown, selectedLabel:label}) 
      this.closeDropdown()
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>